// src/components/reports/theme.js — reports-specific tokens (base layout from PAGE)

import { PAGE, getCardStyle } from '../ui/pageTheme';

export { PAGE };

export const REPORT_COLORS = {
  bg: PAGE.colors.bg,
  surface: PAGE.colors.surface,
  text: PAGE.colors.heading,
  textSecondary: PAGE.colors.muted,
  muted: PAGE.colors.muted,
  line: PAGE.colors.line,
  border: PAGE.colors.border,
  blue: PAGE.colors.info,
  blueSoft: PAGE.colors.infoSoft,
  green: PAGE.colors.success,
  greenSoft: PAGE.colors.successSoft,
  red: PAGE.colors.danger,
  redSoft: PAGE.colors.dangerSoft,
  amber: PAGE.colors.warning,
  amberSoft: PAGE.colors.warningSoft,
};

export const emptyBoxStyle = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: PAGE.colors.muted,
  fontWeight: 700,
  fontSize: 15,
  fontFamily: PAGE.fontFamily,
  ...getCardStyle(),
};
